const initialState = {
  auth: null,
  authBackup: null,
  provider: null,
  tokenUpdate: null
};

export default initialState;
